import React, { useEffect } from 'react'
import 'feather-icons'
import styled from 'styled-components'

import TopTokenList from '../components/TokenList'
import { TYPE } from '../Theme'
import Panel from '../components/Panel'
import { useAllTokenData } from '../contexts/TokenData'
import { useDarkModeManager } from '../contexts/LocalStorage'
import { RowBetween } from '../components/Row'
import Search from '../components/Search'
import { useMedia } from 'react-use'
import Header from '../components/Header'
// import CheckBox from '../components/Checkbox'
// import QuestionHelper from '../components/QuestionHelper'

const DarkPageContainer = styled.div`
  background: ${({ theme }) => theme.bg1};
  min-height: 100vh;
  padding: 120px 48px 80px;
  margin-top: 0;
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  @media screen and (max-width: 768px) {
    padding: 60px 20px 80px;
  }
`

function AllTokensPage() {
  const allTokens = useAllTokenData()
  const [, toggleDarkMode] = useDarkModeManager()

  useEffect(() => {
    window.scrollTo(0, 0)
    // Force dark mode for this page
    toggleDarkMode(true)
  }, [toggleDarkMode])

  const below600 = useMedia('(max-width: 800px)')

  // const [useTracked, setUseTracked] = useState(true)

  return (
    <>
      <Header />
      <DarkPageContainer>
        <RowBetween>
          <TYPE.largeHeader>Top Tokens</TYPE.largeHeader>
          {!below600 && <Search small={true} />}
        </RowBetween>
        {/* <AutoRow gap="4px">
          <CheckBox checked={useTracked} setChecked={() => setUseTracked(!useTracked)} text={'Hide untracked tokens'} />
          <QuestionHelper text="USD amounts may be inaccurate in low liquiidty pairs or pairs without ETH or stablecoins." />
        </AutoRow> */}
        <Panel style={{ marginTop: '6px', padding: below600 && '1rem 0 0 0 ' }}>
          <TopTokenList tokens={allTokens} itemMax={50} />
        </Panel>
      </DarkPageContainer>
    </>
  )
}

export default AllTokensPage
